// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, put, post, del } from "./api_client";
import { AlertWebhook, IAlertWebhook, AlertWebhookTestResult, IAlertWebhookTestResult } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function list(organizationId?: string): ApiResult<AlertWebhook[]> {
		const queryParams = [organizationId !== undefined ? `organizationId=${organizationId}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IAlertWebhook[]>(`/api/alertwebhook/${query}`).then(result => result === undefined ? undefined : result.map(o => new AlertWebhook(o)));
}

export async function create(body: AlertWebhook): ApiResult<AlertWebhook> {
	return post<IAlertWebhook>(`/api/alertwebhook`, body).then(result => result === undefined ? undefined :  new AlertWebhook(result));
}

export async function update(id?: string, body?: AlertWebhook): ApiResult<AlertWebhook> {
	return put<IAlertWebhook>(`/api/alertwebhook/${ id }`, body).then(result => result === undefined ? undefined :  new AlertWebhook(result));
}

export async function deleteWebhook(id?: string): ApiResult<undefined> {
	return del(`/api/alertwebhook/${ id }`);
}

export async function test(id?: string): ApiResult<AlertWebhookTestResult> {
	return post<IAlertWebhookTestResult>(`/api/alertwebhook/${ id }/test`).then(result => result === undefined ? undefined :  new AlertWebhookTestResult(result));
}
